import React, { useEffect } from 'react';
import { MetaPixel } from './components/MetaPixel';
import { StickyHeader } from './components/StickyHeader';
import { Hero } from './components/Hero';
import { ProblemBlock } from './components/ProblemBlock';
import { SocialProofBar } from './components/SocialProofBar';
import { DifferentiationBlock } from './components/DifferentiationBlock';
import { HowItWorks } from './components/HowItWorks';
import { ProductIntro } from './components/ProductIntro';
import { WorkbooksSection } from './components/WorkbooksSection';
import { BonusesSection } from './components/BonusesSection';
import { ValueStack } from './components/ValueStack';
import { AudienceSection } from './components/AudienceSection';
import { Testimonials } from './components/Testimonials';
import { Guarantee } from './components/Guarantee';
import { ClosingBlock } from './components/ClosingBlock';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
import { SocialProofPopup } from './components/SocialProofPopup';
import { FloatingCTA } from './components/FloatingCTA';
export function App() {
  useEffect(() => {
    document.title = 'CHIMICA VISIVA™ | Risorse digitali pronte all’uso per insegnare chimica';
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.setAttribute('name', 'description');
      document.head.appendChild(metaDescription);
    }
    metaDescription.setAttribute('content', 'CHIMICA VISIVA™ è il sistema didattico digitale completo per insegnare chimica in Italia: schede teoriche visive, attività, laboratori, verifiche A/B, soluzioni per il docente, giochi e progetti scientifici. Pagamento unico e accesso immediato.');
  }, []);
  return <div className="w-full bg-paper text-ink" data-id="element-0" data-mp="nvan5e2e2r9s">
      <MetaPixel data-id="element-1" data-mp="su42lc18kscl" />
      <StickyHeader data-id="element-2" data-mp="stkjhrzunxwz" />
      <main data-id="element-3" data-mp="sssq8ntq6c9v">
        <span id="hero-sentinel" aria-hidden="true" data-id="element-4" data-mp="swqbpg3rzfwx" />
        <Hero data-id="element-5" data-mp="35gkl05ue1ig" />
        <ProblemBlock data-id="element-6" data-mp="356wji4cy4fe" />
        <SocialProofBar data-id="element-7" data-mp="38kxclxdi5kq" />
        <DifferentiationBlock data-id="element-8" data-mp="3ud1hdeu8fyd9" />
        <HowItWorks data-id="element-9" data-mp="3ubrgkhvzwc2x" />
        <ProductIntro data-id="element-10" data-mp="3uc9i9u1ffii8" />
        <WorkbooksSection data-id="element-11" data-mp="3uf5ijp0qyj9u" />
        <BonusesSection data-id="element-12" data-mp="d57gn6a1wokn" />
        <ValueStack data-id="element-13" data-mp="d3mm3gnql5ms" />
        <AudienceSection data-id="element-14" data-mp="d3wd97kipiu2" />
        <Testimonials data-id="element-15" data-mp="d2bf77yzvhrg" />
        <Guarantee data-id="element-16" data-mp="851lhg4kojxt" />
        <ClosingBlock data-id="element-17" data-mp="86mh792mi8x9" />
        <FAQ data-id="element-18" data-mp="86cnpbiddjmt" />
        <Footer data-id="element-19" data-mp="83i0xdbvvmq8" />
        <div className="h-[54px] md:hidden" aria-hidden="true" data-id="element-20" data-mp="3gle90gn0mze4" />
        <SocialProofPopup data-id="element-21" data-mp="3glnzs6fvxakv" />
        <FloatingCTA data-id="element-22" data-mp="3bmbdpnwu87jc" />
      </main>
    </div>;
}